import { Injectable } from '@angular/core';

import { AuthGuard } from '@platform/auth/auth.guard';
import { CompositeGuard } from '@platform/routing/composite.guard';

import { ContactsGuard } from './contacts.guard';

@Injectable({
  providedIn: 'root',
})
export class ContactsCompositeGuard extends CompositeGuard {
  constructor(authGuard: AuthGuard, contactsGuard: ContactsGuard) {
    super([authGuard, contactsGuard]);
  }
}
